import { withTranslation } from 'react-i18next';

import ManageUsers from './ManageUsers';

export default withTranslation()(ManageUsers);
